import { PHYSICAL_CONDITION_ITEMS } from '@/pages/ai-consultation/components/physical-condition';
import { PHYSICAL_CONDITION_LEVELS } from '@/pages/ai-consultation/components/physical-condition-level';
import cx from './index.module.scss';

interface PhysicalImproveItemProps {
  name: string;
  value?: number;
  onChange?: (value: number) => void;
}

const PhysicalImproveItem = (props: PhysicalImproveItemProps) => {
  const { value, name, onChange } = props;

  return (
    <div className={cx('item')}>
      <div className={cx('name')}>{name === 'stayUpLate' ? '熬夜' : PHYSICAL_CONDITION_ITEMS[name]?.name}</div>
      <div className={cx('level-wrapper')}>
        {PHYSICAL_CONDITION_LEVELS?.map(item => (
          <div
            onClick={() => onChange(item?.level)}
            className={cx('selector-item', { active: value === item?.level })}
            key={item?.name}
          >
            <div className={cx('name')}>{item.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PhysicalImproveItem;
